import { useEffect, useState } from "react";
import { getData } from "../utils/apiCalls";
import { imgs } from "../assets/imgs";
import { updateTags } from "../utils/funcs";

export const TYSubmission = () => {

    useEffect(() => {
        updateTags("youngStartup Ventures | Thank You")
    }, [])

    const [currentEvent, setCurrentEvent] = useState({});
    useEffect(() => {
        getData(`https://youngstartup.io/api/cwebsite/get_current_event`)
            .then(res => {
                const title = res.title;
                const calender_links = JSON.parse(res.calender_links);
                setCurrentEvent({ title, calender_links });
            })
    }, [])

    return (
        <div style={{ backgroundColor: "black" }}>
            <div
                style={{
                    textAlign: "center",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: '4em',
                }}
            >
                <h1 style={{ fontWeight: "700", fontSize: '2.5em' }}>Thank you for your submission!</h1>
                <br />
                <h4 style={{ fontSize: '1.5em' }}>Please add {currentEvent.title} to your Calendar:</h4>
                <br />
                <div style={{ margin: '2em', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2em' }}>
                    <a rel='noreferrer' target="_blank" href={currentEvent.calender_links?.google}>
                        <img alt='google' border="0" src={imgs.icons.google} style={{ width: '50px' }} />
                    </a>
                    <a rel='noreferrer' target="_blank" href={currentEvent.calender_links?.ics_file} download>
                        <img alt='apple' border="0" src={imgs.icons.apple} style={{ width: '50px' }} />
                    </a>
                    <a rel='noreferrer' target="_blank" href={currentEvent.calender_links?.ics_file} download>
                        <img alt='outlook' border="0" src={imgs.icons.outlook} style={{ width: '50px' }} />
                    </a>
                </div>
                <div>
                    Be on the lookout for email communication with important updates
                    from <span><a style={{ color: 'blue' }} href="mailto:peter@youngstartup.com">Peter@youngstartup.com</a></span>
                </div>
                <br />
                <div>Best regards,</div>
                <div>The youngStartup Team</div>
            </div>
        </div>
    );
};
